import { translate } from 'App/Internationalization';
import FormField from 'shared/Forms/Fields/FormField';
import InputCity from 'shared/Forms/Inputs/Address/InputCity';
import React from 'react';

export default class FieldCity extends React.Component {
	render() {
		const label = translate('global.forms.inputs.address.city.label');

		return (
			<FormField
				className={this.props.className}
				inputName={this.props.name}
				labelClass={this.props.labelClass}
				label={this.props.label ?? label}
				name={this.props.name}
				required={this.props.required}
			>
				<InputCity
					className={this.props.inputClass}
					disabled={this.props.disabled}
					name={this.props.name}
					required={this.props.required}
				/>
			</FormField>
		);
	}
}

FieldCity.defaultProps = {
	className: InputCity.defaultProps.className,
	disabled: InputCity.defaultProps.disabled,
	inputClass: InputCity.defaultProps.className,
	labelClass: FormField.defaultProps.labelClass,
	name: InputCity.defaultProps.name,
	required: InputCity.defaultProps.required,
};
